<!--  -->
<template>
<div class="headerBox" :style="{position: showFirst ? 'static' : 'sticky', borderBottom: showFirst ? 'none' : '1px solid #F5F8FA'}">
    <div class='headerWrapper' >
        <div class="flexRow HtopBox pcheader">
            <div class="flexRow leftBox ">
                <div class="flexRow Hlogo"><img src="@/assets/common/imgs/PCimg/Hlogo.png" alt=""></div>
                <div class="flexRow HsearchBox" v-if="activeIndex == 1 && ($router.history.current.name == 'hundred' || $router.history.current.name == 'seriesLesson' || $router.history.current.name ==  'search')">
                    <el-input class="sInput" placeholder="请输入要搜索的课程或关键词"  @keyup.enter.native="searchFun" v-model="searchValue"> <i @click="searchFun" slot="suffix" class="el-input__icon el-icon-search pointer"></i></el-input>
                </div>
            </div>
            <div class="flexRow rightBox">
                <div class="flexRow vip pointer" @click="navgitater" ><img src="@/assets/common/imgs/PCimg/VIP.png" alt="" >开通会员</div>
                <div class="flexRow">
                    <el-popover  placement="bottom" width="112" trigger="hover">
                        <div class="gzhWrapr">
                            <div class="gzhpopover">微信扫码 <br/>下载英才苑府App</div>
                            <img src="@/assets/common/imgs/PCimg/appLoadCode.png" alt="">
                        </div>
                        <span slot="reference">App下载</span>
                    </el-popover>
                </div>
                <div class="flexRow gzh">
                    <el-popover  placement="bottom" width="112" trigger="hover">
                        <div class="gzhWrapr">
                            <div class="gzhpopover">微信关注英才苑府服务号<br/>获取更多学习咨询</div>
                            <img src="@/assets/common/imgs/icon/gzhCode.png" alt="">
                        </div>
                        <span slot="reference">公众号</span>
                    </el-popover>
                </div>
                <div class="flexRow infoImg" v-if="headerInfo.MemberName">
                    <el-popover  placement="bottom" width="365" trigger="hover">
                        <div class="infoDownWrap">
                            <div class="infoLogo flexRow" @click="goToEditUser">
                                <div class="leftLogo" v-if="loginInfo.Photo"><img :src="loginInfo.Photo" alt=""></div>
                                <div class="leftLogo" v-else><img src="@/assets/common/imgs/icon/info_icon.png" alt=""></div>
                                <div class="rightLogo flexCol">
                                    <div class="infoName flexRow pointer">
                                        <div>{{headerInfo.MemberName}}</div>
                                        <svg-icon icon-class="right" class="rightSize" />
                                    </div>
                                    <div class="companyName">{{headerInfo.CompanyName}}</div>
                                </div>
                            </div>
                            <div class="infoStudy flexRow">
                                <div class="comStudy pointer flexCol" @click="navToFun('myXueshi')">
                                    <div class="Num">{{headerInfo.ShowHours||0}}</div>
                                    <div class="studyName">我的学时/h</div>
                                </div>
                                <div class="comStudy flexCol pointer" @click="navToFun('integInfo')">
                                    <div class="Num">{{headerInfo.Jifen||0}}</div>
                                    <div class="studyName">我的积分</div>
                                </div>
                                <div class="comStudy flexCol pointer" @click="navToFun('address')"> 
                                    <div class="Num">{{headerInfo.addresNum||0}}</div>
                                    <div class="studyName">我的地址/邮箱</div>
                                </div>
                            </div>
                            <div class="classCourseWrap flexRow">
                                <div class="comCourse pointer flexCol" @click="navToFun('userCenter?tab=1')">
                                    <div class="icon">
                                        <img src="@/assets/common/imgs/icon/icon_ybf.png" alt="">
                                    </div>
                                    <div class="Text">英才100分</div>
                                </div>
                                <div class="courseLine"></div>
                                <div class="comCourse pointer flexCol" @click="navToFun('userCenter?tab=2')">
                                    <div class="icon">
                                        <img src="@/assets/common/imgs/icon/icon_xlk.png" alt="">
                                    </div>
                                    <div class="Text">精品系列课程</div>
                                </div>
                                <div class="courseLine"></div>
                                <div class="comCourse pointer flexCol" @click="navToFun('userCenter?tab=3')">
                                    <div class="icon">
                                        <img src="@/assets/common/imgs/icon/icon_ythk.png" alt="">
                                    </div>
                                    <div class="Text">一堂好课</div>
                                </div>
                                <div class="courseLine"></div>
                                <div class="comCourse pointer flexCol" @click="navToFun('userCenter?tab=4')">
                                    <div class="icon">
                                        <img src="@/assets/common/imgs/icon/icon_xxszk.png" alt="">
                                    </div>
                                    <div class="Text">线下实战课</div>
                                </div>
                            </div>
                            <!-- <div class="LawyerPart flexRow">
                                <div class="comBox leftBox">
                                    <div class="BigText">实习律师专区</div>
                                    <div class="smallText">点击进入</div>
                                </div>
                                 <div class="comBox rightBox">
                                    <div class="BigText">法院专区</div>
                                    <div class="smallText">点击进入</div>
                                </div>
                            </div> -->
                            <div class="infoSet flexRow">
                                <div class="setCom flexCol" @click="goToUserCenter">
                                    <div class="setImg"><img src="@/assets/common/imgs/icon/icon_member.png" alt=""></div>
                                    <div class="setText">个人中心</div>
                                </div>
                                <!-- <div class="setCom flexCol pointer">
                                    <div class="setImg"><img src="@/assets/common/imgs/icon/icon_set.png" alt=""></div>
                                    <div class="setText">个人设置</div>
                                </div> -->
                                <div class="setCom flexCol pointer" @click="quitLogin">
                                    <div class="setImg"><img src="@/assets/common/imgs/icon/icon_quit.png" alt=""></div>
                                    <div class="setText">退出登录</div>
                                </div>
                            </div>
                        </div>
                        <span slot="reference">
                            <div class="flexRow infoWrap">
                                <!-- <img class="leftImg" src="@/assets/common/imgs/icon/info_icon.png" alt=""> -->
                                <img class="leftImg" v-if="loginInfo.Photo" :src="loginInfo.Photo" alt="">
                                <img v-else class="leftImg" src="@/assets/common/imgs/icon/info_icon.png" alt="">
                                <svg-icon icon-class="down" class="downSize" />
                            </div>
                        </span>
                    </el-popover>
                </div>
                <div class="flexRow pointer" v-if="!loginInfo.Token" @click="openLogin">登录</div>
                <!-- <div class="flexRow" v-if="!loginInfo.Token">注册</div> -->
            </div>
        </div>
        <div class="flexRow pcHeaderTab pcheader" :style="{height: showFirst ? 'auto' : '60px'}" v-if="isShowTab">
            <div class="topFirst" v-if="showFirst">
                <img class="icon_allClass" src="@/assets/common/imgs/icon/icon_allClass.png" alt="">
                <span>全部课程</span>
            </div>
            <div class="TbaText pointer" v-for="(item,index) in TabArr" @click='navToFun(item.path)'  :class="{'HActive':activeIndex==index}" :key="index">{{item.Text}} <img class="HhotIcon" v-if="item.isHot" src="@/assets/common/imgs/PCimg/hoticon.png" alt="" srcset=""></div>

            <div class="cartBtn" @click="goToCart" v-if="activeIndex == 101">
                <el-badge :hidden="!chrtNum" :value="chrtNum" class="item">
                    <img src="@/assets/common/imgs/icon/icon_cart.png" alt="">
                </el-badge>
                <span>我的购物车</span>
            </div>
        </div>
        <div class="mobileHWrap flexCol">
            <div class="Htop flexRow" >
                <div class="topMenu pointer" @click="opendrawer">
                    <svg-icon icon-class="menu" class="menuSize"></svg-icon>
                </div>
                <el-drawer direction="ltr" class="drawerWrapper" @close="closeDrawer" :modal-append-to-body="false" size="45%" :visible.sync="drawer"  :with-header="false">
                    <div class="HsearchBox flexRow"><van-search v-model="value" placeholder="请输入搜索关键词" /></div>
                    <div class="TbaText pointer comApp" @click="navToFun(item.path)" v-for="(item,index) in TabArr" :class="{'HActive':activeIndex==index}" :key="index">{{item.Text}}<img class="HhotIcon" v-if="item.isHot" src="@/assets/common/imgs/PCimg/hoticon.png" alt="" srcset=""></div>
                    <div class="flexRow comApp pointer" v-if="!loginInfo.Token" @click="openLogin">登录</div>
                    <div class="flexRow comApp pointer" v-if="loginInfo.Token" @click="quitLogin">退出登录</div>
                    <!-- <div class="flexRow comApp pointer" v-if="!loginInfo.Token">注册</div> -->
                </el-drawer>
                <div class="topimg Hmiddle"><img src="@/assets/common/imgs/PCimg/Hlogo.png" alt=""></div>
                <div class="topimg Hlogin" ><img src="@/assets/common/imgs/appImg/ycyf_logo.png" alt=""></div>
            </div>
            <div class="Hbot flexRow" v-if="activeIndex == 1 && ($router.history.current.name == 'hundred' || $router.history.current.name == 'seriesLesson' || $router.history.current.name ==  'search')">
                <van-search  @search="searchFun" v-model="searchValue" placeholder="请输入搜索关键词" />
            </div>
        </div>
    </div>
    <login />
    <bindPhone />
    <register />
</div>

</template>

<script>
import login from '@/components/login/login'
import bindPhone from '@/components/login/bindPhone'
import register from '@/components/login/register'
export default {
    props:{
        isShowTab:{
            type:Boolean,
            default:true
        },
        activeIndex:{
            type:Number,
            default:0
        },
        showFirst: {
            type: Boolean,
            default: false
        }
    },
    data() {
     return {
         searchValue:"",
         TabArr:[
             {Text:"首页",isHot:false,path:"/"},
             {Text:"英才100分",isHot:false,path:"/hundred"},
             {Text:"精品系列课程",isHot:true,path:"/seriesLesson"},
             {Text:"一堂好课",isHot:false,path:"/goodLesson"},
             {Text:"线下实战课",isHot:false,path:"/offlineClass"},
             {Text:"直播",isHot:false,path:"/liveBox"},
             {Text:"导师",isHot:false,path:"/teacher"},
            //  {Text:"VIP会员",isHot:true,path:"/VIP"},
            //  {Text:"答疑解惑",isHot:false,path:"/answer"},
            //  {Text:"心选商城",isHot:false,path:"/shop"},
         ],
        
        direction: 'rtl',
        value:"",
     };
    },
    mounted() {
        
    },
    methods: {
        goToEditUser() {
            this.$router.push({
                name: 'editUserInfo'
            })
        },
        goToCart() {
            this.$router.push({
                name: 'shopCart'
            });
        },
        navToFun(url){
            // console.log(url, this.$router)
            // if (this.$router.history.current.name == url.split('?')[0]) {
            //     return false
            // }
            this.$router.push(url);
            this.closeDrawer();
        },
        quitLogin(){
            this.$confirm('您确定要退出登陆吗, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                sessionStorage.clear();
                this.drawer=false;
                this.$store.commit('setLoginInfo', {});
                this.$store.commit('setheaderInfo', {});
                this.$store.commit('setMobileToken', '');
                // this.$store.commit('changeShowLoginState', true)
                window.location.reload();
            }).catch(() => {
                this.drawer=false;
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
        navgitater(){
            this.$router.push('/VIP')
        },
        searchFun(){
            console.log(this.searchValue)
            let name = this.$router.history.current.name
            let type = name == 'hundred' == 1 ? 1 : (name == 'seriesLesson' ? 2 : '')
            this.$router.push({
                name: 'search',
                query: {
                    type,
                    searchValue: this.searchValue
                }
            })
            // if (name == 'hundred') {

            // }
            // if (name == 'seriesLesson') {

            // }
        },
        
        openLogin() {
            this.$store.commit('changeShowLoginState', true)
        },
        nagative(item){
            
        },
        goToUserCenter(){
            this.$router.push({
                name: 'userCenter'
            })
        },opendrawer(){
            this.$store.commit('setDrawerState', true);
        },
        closeDrawer(){
            this.$store.commit('setDrawerState', false)
        },
    },
    components:{
        login,
        bindPhone,
        register
    },
    created() {
    
    },
    computed:{
        loginInfo: {
            get() {
                return this.$store.state.loginInfo;
            },
            set() {},
        },
        headerInfo:{
            get() {
                return this.$store.state.headerInfo;
            },
            set() {},
        },
        drawer:{
            get() {
               return this.$store.state.DrawerState;
            },
            set() {},      
        },
        chrtNum:{
            get() {
               return this.$store.state.chrtNum;
            },
            set() {},      
        },
        
    },
    watch: {},
}
</script>
<style scope lang='scss' >
.headerBox {
    width: 100%;
    position: sticky;
    top: 0;
    z-index: 999;
    background: #fff;
    border-bottom: 1px solid #F5F8FA;
}
@media screen and (min-width:1024px){
    .headerWrapper{
        .HtopBox{
            width: 1210px;
            height:90px;
            margin: 0 auto;
            align-items: center;
            justify-content: space-between;
        }
        .pcHeaderTab{
            width: 1050px;
            height: 56px;
            margin: 0 auto;
            align-items: center;
            justify-content: flex-start;
            .topFirst {
                width: 160px;
                height: 56px;
                background: #2075F5;
                text-align: center;
                line-height: 56px;
                font-size: 15px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                margin-right: 30px;
                .icon_allClass {
                    width: 13px;
                    height: 9px;
                }
            }
            .TbaText{
                font-size: 15px;
                font-family: PingFang SC;
                font-weight: 400;
                color:#666666;
                margin-right: 30px;
                position: relative;
                .HhotIcon{
                    position: absolute;
                    top:-10px;
                    right: -18px;
                }
            }
            .HActive{
                color:#2075F5;
                font-weight: bold;
            }
            .cartBtn {
                cursor: pointer;
                margin-left: 200px;
                width: 130px;
                height: 40px;
                border: 1px solid #D3D3D3;
                border-radius: 4px;
                text-align: center;
                line-height: 40px;
                font-size: 13px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #2075F5;
            }
        }
        .mobileHWrap{display: none;}
        .leftBox{
            align-items: center;
            .Hlogo{
                img{
                    width: 166px; 
                }
            }
            .HsearchBox{
                width: 350px;
                margin-left: 40px;
                height:40px;
                .el-input__inner{
                    border: 0;
                    background: #F5F5F5;
                    border-radius: 40px;
                    &::placeholder {
                        color: #777777;
                        font-size: 12px;
                        line-height: 27px;
                    }
                    .el-input__icon{
                        line-height: 27px;
                    }
                }
                
            }
        }
        .rightBox{
            justify-content: space-between;
            align-items: center;
            width: 480px;
            font-size: 14px;
            color:#666666;
            .vip{
                color:#C89054;
                align-items: center;
                font-size: 14px;
                img{
                    width: 17px;
                    height: 14px;
                    margin-right:4px;
                }
            }
            .infoImg{
                width:56px;
                background: #F5F5F5;
                border-radius: 20px;
                justify-content: center;
                padding:4px 6px;
                .infoWrap{
                    align-items: center;
                    .leftImg{
                        width: 26px;
                        border-radius: 50%;
                    }
                    .downSize{
                        width: 18px;
                        margin-left: 6px;
                    }
                    
                }
            }
        }
        
    }
    
    .gzhWrapr{
        border-radius: 10px;
        padding-bottom:10px;
        .gzhpopover{
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
            background: #2075F5;
            padding:8px 0;
            color:#FFFFFF;
            font-size: 12px;
            text-align: center;
        }
        img{
            font-size: 0;   
            width: 100%;
        }
    }
    .infoDownWrap{
        border-radius: 10px;
        padding-bottom:10px;
        padding:24px 24px 33px 24px;
        .infoLogo{
            cursor: pointer;
            align-items: center;
            .leftLogo{
                img{
                    border-radius: 50%;
                    width: 43px;
                }
            }
            .rightLogo{
                margin-left: 13px;
                .infoName{
                    align-items: center;
                    div{
                        font-size: 18px;
                        font-family: PingFang SC;
                        font-weight: bold;
                        color: #333333;
                        margin-right: 8px;
                    }
                    .rightSize{
                        width: 16px;
                    }
                }
                .companyName{
                    font-size: 12px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    color: #666666;
                }
            }
        }
        .infoStudy{
            justify-content: space-around;
            margin: 18px 0;
            .comStudy{
                justify-content: center;
                align-items: center;
                text-align: center;
                .Num{
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: bold;
                    color: #333333;
                }
                .studyName{
                    margin-top: 9px;
                    font-size: 12px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    color: #999999;
                }
            }
        }
        .classCourseWrap{
            justify-content: space-between;
            width: calc(100% - 36px);
            background: #F5F5F5;
            border-radius: 6px;
            padding: 14px 18px;
            .comCourse{  
                text-align: center;
                .icon{
                    margin: 0 auto;
                    text-align: center;
                    width: 22px;
                    height: 24px;
                }
                .Text{
                    text-align: center;
                    margin-top: 20px;
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #333333;
                }
            }
            .courseLine{
                width: 1px;
                height: auto;
                background: #E5E5E5;
            }
        }
        .LawyerPart{
            justify-content: space-between;
            align-items:stretch;
            margin-top:15px;
            .comBox{
                height: 65px;
                width: 100%;
                background: chartreuse;
                .BigText{
                    margin:13px 0 0 15px;
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: bold;
                    color: #FFFFFF;
                }
                .smallText{
                    margin:6px 0 0 15px;
                    font-size:  10px;
                    font-family: PingFang SC;
                    font-weight: bold;
                    color: #FFFFFF;
                }
            }
            .leftBox{
                background: url("./../assets/common/imgs/icon/1bg.png") no-repeat;
                background-size: 100% 100%;
            }
            .rightBox{
                background: url("./../assets/common/imgs/icon/1-bg.png") no-repeat;
                background-size: 100% 100%;
                margin-left: 15px;
            }
        }
        .infoSet{
            justify-content: space-around;
            align-items: center;
            margin-top:30px;
            .setCom{
                cursor: pointer;
                justify-content: center;
                align-items: center;
                .setImg{
                    text-align: center;
                    margin-bottom: 8px;
                }
                .setText{
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    color: #888888;
                }
            }
        }
    }
}
@media screen and (max-width: 1024px) {
    .headerWrapper{
        .pcheader{
            display: none;
        }
        .mobileHWrap{
            display: inline-block;
            padding:20px;
            width:calc(100% - 40px);
            .Htop{
                justify-content: space-between;
                width:100%;
                align-items: center;
                padding-bottom:20px;
                border-bottom: 1px solid #efefef;
                .drawerWrapper{
                    .el-drawer__body{
                        background:#3f3f3f; 
                        padding:30px;
                        color:#FFFFFF;
                        .HsearchBox{
                            height:220px;
                            width: 100%;
                            align-items: center;
                            .van-search{
                                width: 100%;
                                border-radius: 30px;
                                .van-field__left-icon{
                                    line-height:50px;
                                    .van-icon-search{
                                        font-size: 30px;
                                    }
                                }
                                .van-field__control{
                                    
                                height: 50px; font-size: 28px;
                                    &::placeholder{
                                        font-size: 30px;
                                    }
                                }
                            }
                        }
                    }
                   .comApp{
                       margin:60px 30px;
                   }
                   .TbaText{
                      position: relative;
                      width: fit-content;
                      .HhotIcon{
                            position: absolute;
                            top:-32px;
                        }
                   }
                   .HActive{
                        color:#2075F5;
                        font-weight: bold;
                    } 
                }
                .topMenu{
                    font-size: 50px;
                }
                .Hmiddle{
                    img{
                        width: 300px;
                    }
                }
                .Hlogin{
                    img{
                        width: 120px;
                    }
                } 
            }
            .Hbot{
                height:180px;
                align-items: center;
                border-bottom: 1px solid #efefef;
                .van-search{
                    width: 100%;
                    font-size: 30px;
                    .van-field__left-icon{
                        line-height:80px;
                        .van-icon-search{
                            font-size: 30px;
                        }
                    }
                    .van-field__control{
                       height: 80px; 
                       &::placeholder{
                           font-size: 30px;
                       }
                    }
                }
            }
        }
        
    }
}


</style>


// WEBPACK FOOTER //
// src/components/Header.vue